import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DiagramsReducer, IDiagramData, ISelectParam } from 'types/mainPage';

const initialState: DiagramsReducer = {
  diagramData: [],
  selectParams: [],
  currentParam: '',
};

export const diagramsSlice = createSlice({
  initialState,
  name: 'diagrams',
  reducers: {
    setSelectParams(state, action: PayloadAction<ISelectParam[]>) {
      state.selectParams = action.payload;
    },
    setDiagramData(state, action: PayloadAction<IDiagramData[]>) {
      state.diagramData = action.payload;
    },
    setCurrentParam(state, action: PayloadAction<string>) {
      state.currentParam = action.payload;
    },
    resetDiagrams() {
      return initialState;
    },
  },
});

export default diagramsSlice.reducer;
